import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import EditIcon from '@mui/icons-material/Edit';

import { drillFragmentData, graphql } from '@e-socna/data-layer';

import { useFolderAccess } from '../../components/Access/hooks/useFolderAccess.hook';
import { RightDrawer } from '../../components/RightDrawer';
import { FormVariant } from '../../forms';
import { AddressWithMap } from '../../components/AddressWithMap';
import { FolderForm } from '../../forms/Folder';
import { FolderFormTab } from '../../forms/Folder/enums/tab.enum';
import { useFolderReadyContext } from '../../contexts/FolderContext/hooks/useFolderReadyContext.hook';

import { FolderPage_Tabs_Folder_Fragment } from './Tabs';

export const FolderPage_Address_Folder_Fragment = graphql(`
  fragment FolderPage_Address_Folder_Fragment on Folder {
    _id

    consolidation {
      address {
        ...AddressWithMapCmp_Address_Fragment
      }
    }

    ...FolderForm_Folder_Fragment
  }
`);

interface Props {
  readonly paths: Readonly<{
    consult: string;
    edit: string;
  }>;
}

export const Address = ({ paths }: Readonly<Props>) => {
  const { folder: rawFolder } = useFolderReadyContext();
  const folder = drillFragmentData(
    [FolderPage_Tabs_Folder_Fragment, FolderPage_Address_Folder_Fragment],
    rawFolder,
  );

  const {
    consolidation: { address },
  } = folder;

  const { pathname: currentPath } = useLocation();
  const navigate = useNavigate();

  const isInEditionMode = currentPath === paths.edit;
  const leaveEditionMode = useCallback(
    () => void navigate(paths.consult),
    [navigate, paths.consult],
  );

  const access = useFolderAccess(folder._id, folder);

  return (
    <>
      <AddressWithMap
        address={address}
        editAction={{
          id: 'editFolderAddress',
          gate: access.update,
          icon: <EditIcon />,
          name: 'Modifier Adresse',
          to: paths.edit,
        }}
        id={folder._id}
        sx={{ mt: 4 }}
      />
      <RightDrawer isOpen={isInEditionMode} onDrawerClose={leaveEditionMode}>
        <FolderForm
          folderId={folder._id}
          formVariant={FormVariant.Modification}
          initialValues={folder}
          onCancel={leaveEditionMode}
          onSuccess={leaveEditionMode}
          stepIdsSubset={[FolderFormTab.Address]}
          title="Formulaire de modification de l'Adresse du Dossier"
        />
      </RightDrawer>
    </>
  );
};
